<template>
  <div class="room-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="room-viewer__content">
      <AppMapPointPanelFirstRow @edit="edit" :title="room.name" :id="room.id" :img="avatarSrc" :has-edit="can(PN.ROOM_UPDATE)" :has-preview="hasPreview" />
      <table class="table user-view-table m-0">
        <tbody>
          <tr v-if="room.phone">
            <td>Phone:</td>
            <td>{{ room.phone }}</td>
          </tr>
          <tr v-if="room.calendar_url">
            <td>Calendar:</td>
            <td><a :href="room.calendar_url" target="_blank">view calendar</a></td>
          </tr>
          <tr v-if="room.data_jack">
            <td>Data jack nums:</td>
            <td>{{ room.data_jack }}</td>
          </tr>
          <tr v-if="room.voice_jack">
            <td>Voice jack nums:</td>
            <td>{{ room.voice_jack }}</td>
          </tr>
          <tr v-if="room.note">
            <td>Note:</td>
            <td class="multiline">{{ room.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { getAvatarSrc } from '@/utils/Helpers'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'
import { getIconUrl } from '@/components/leaflet/Icon'

export default {
  name: 'RoomViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({ PN }),
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    point: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('room', ['getRoom']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Room')
    },
    room() {
      return this.getRoom(this.id) || {}
    },
    iconSrc() {
      return getIconUrl(this.point.icon_id, this.point.file_updated_at)
    },
    hasPreview() {
      return this.room.avatar_id
    },
    avatarSrc() {
      return getAvatarSrc(this.room.avatar_id, this.room.avatar_updated_at, this.iconSrc)
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.room-viewer__content {
  padding: 24px;
}
</style>
